<template>
  <div class="custom-list">
    <v-row v-if="titleSection" no-gutters class="ma-0">
      <v-col cols="12" class="">
        <v-card elevation="0" class="pa-6 list-box-Shadow light_background">
          <v-row no-gutters class="">
            <v-col cols="6" class="text-left d-flex align-center" v-if="title">
              <h3
                class="text-uppercase text-h6 text_color--text font-weight-bold"
              >
                {{ title }}
              </h3>
            </v-col>
            <v-col
              :cols="title ? '6' : '12'"
              class="d-flex justify-end"
              v-if="hasListActions"
            >
              <slot name="listAction" />
            </v-col>
            <v-col cols="12" v-if="hasAfterTitle">
              <slot name="afterTitle" />
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <v-row
      no-gutters
      class="white pa-6 rounded-lg"
      :class="noMargin ? 'ma-0' : 'mt-3 mx-5 mb-5'"
    >
      <v-col cols="12" v-if="hasFilter">
        <v-row no-gutters>
          <v-col cols="2" class="d-flex app-search-input d-flex align-center">
            <BaseTextInput
              :name="name"
              :id="id"
              label="Search"
              hide-details="auto"
              prepend-inner-icon="mdi-magnify"
              v-model="search"
              outlined
              dense
              clearable
              @keydown.enter="itemsPerPageChanged(itemsPerPage)"
              @click:clear="clearSearch"
            ></BaseTextInput>
            <BaseButton
              v-if="isMagnifyIcon"
              id="magnifySearchBtn"
              x-small
              fab
              depressed
              color="primary"
              class="ml-1 rounded-lg btn-small"
              @click="itemsPerPageChanged(itemsPerPage)"
            >
              <v-icon>mdi-magnify</v-icon>
            </BaseButton>
            <slot name="leftFilterSlot" />
          </v-col>
          <v-col>
            <slot name="extraSpace"></slot>
          </v-col>
          <v-col cols="col-3" class="d-flex">
            <slot name="rightFilterSlot" />
            <div v-if="hasFilter">
              <BaseColumnController
                v-if="isColumnShowVisibility"
                :gridColInstance="gridColumnApi"
                :headers="tableHeader"
                :hideColumns="fieldsNotInColumnSelect"
                :localStorageKey="localStorageKey"
                @headersChanged="headersChanged"
              />
            </div>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12" :class="noMargin ? 'ma-0' : 'mt-8'">
        <AgGridVue
          :style="gridStyle"
          class="ag-theme-alpine"
          :columnDefs="tableHeader"
          :default-col-def="defaultColDef"
          :context="{ ...context, ...listParentComponentContext }"
          :grid-options="hasOtherGridOptions ? otherGridOption : gridOptions"
          :suppressDragLeaveHidesColumns="true"
          :rowData="tableData"
          v-on="$listeners"
          @selection-changed="onSelectionChanged"
          @grid-ready="onGridReady"
          :enableBrowserTooltips="true"
        ></AgGridVue>
      </v-col>
      <v-col v-if="total > 0" cols="12" class="py-0 pt-5">
        <v-row>
          <v-col cols="6" class="d-flex align-center justify-start">
            <BasePaginationCount :total="total" />
          </v-col>
          <v-col cols="6" class="d-flex justify-end">
            <BasePagination
              :pageNo="pageNo"
              :totalItems="total"
              :pageSize="itemsPerPage"
              @itemsPerPageChange="itemsPerPageChanged"
              @prevPage="prevPage"
              @nextPage="nextPage"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <slot name="dialogs" />
    <slot name="detail" />
  </div>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import { AgGridVue } from "ag-grid-vue";
import BaseColumnController from "@/components/BaseComponents/BaseColumnController.vue";
// import BaseCustomHeader from "dash-component-library";

export default {
  components: {
    AgGridVue,
    // agColumnHeader: BaseCustomHeader,
    BaseColumnController,
  },
  props: {
    id: {
      required: true,
    },
    name: {
      required: true,
    },
    titleSection: {
      type: Boolean,
      default: true,
    },
    localStorageKey: {
      type: String,
      default: null,
    },
    isColumnShowVisibility: {
      type: Boolean,
      default: false,
    },
    isMagnifyIcon: {
      type: Boolean,
      default: false,
    },
    fieldsNotInColumnSelect: {
      type: Array,
      default: () => ["warning", "actions"],
    },
    title: {
      required: false,
    },
    total: {
      type: [Number, String],
      default: 0,
    },
    tableData: {
      type: Array,
      required: true,
    },
    tableHeader: {
      type: Array,
      required: true,
    },
    context: {
      type: Object,
      default: () => {},
    },
    hasFilter: {
      type: Boolean,
      default: true,
    },
    filterClass: {
      type: String,
      default: "d-flex",
    },
    leftFilterSlotClass: {
      type: String,
    },
    filtersOnRight: {
      type: Boolean,
      default: false,
    },
    initialCall: {
      type: Boolean,
      default: true,
    },
    parentComponent: {
      type: Object,
      default: () => {},
    },
    otherGridOption: {
      type: Object,
    },
    hasOtherGridOptions: {
      type: Boolean,
      default: false,
    },
    tableScrollable: {
      type: Boolean,
      default: false,
    },
    setInterval: {
      type: Boolean,
      default: false,
    },
    setIntervalDuration: {
      type: Number,
      default: 1000,
    },
    gridStyle: {
      type: Object,
      default() {
        return {
          width: "100%",
          height: "calc(100vh - 365px)",
        };
      },
    },
    hasAfterTitle: {
      type: Boolean,
      default: true,
    },
    hasListActions: {
      type: Boolean,
      default: true,
    },
    noMargin: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      sorting: {},
      // pagination vars
      itemsPerPage: this.$globalConstant.itemsPerPage,
      pageNo: 1,
      filters: {},
      headersSelected: [],
      defaultColDef: {
        lockPosition: true,
        sorting: true,
        resizable: true,
      },
      gridApi: null,
      columnApi: null,
      gridOptions: {
        onGridSizeChanged: () => {
          this.gridOptions.api.sizeColumnsToFit();
        },
        headerHeight: 40,
        rowHeight: 40,
        rowSelection: "multiple",
        suppressRowClickSelection: true,
        suppressDragLeaveHidesColumns: true,
        enableCellTextSelection: true,
      },
      search: null,

      selectedRows: [],

      timeInterval: null,

      paginationTimeout: null,
    };
  },
  watch: {
    search(val) {
      if (val == "") {
        this.clearSearch();
      }
    },
  },
  computed: {
    offset() {
      return this.itemsPerPage * (this.pageNo - 1);
    },
    listParentComponentContext() {
      return { listParentComponentContext: this };
    },
  },
  methods: {
    searchTriggered() {
      this.itemsPerPageChanged(this.itemsPerPage);
    },
    headersChanged() {
      // setTimeout(() => {
      //   this.autoSizeAll();
      // }, 100);
      if (this.gridOptions && this.gridOptions.api) {
        setTimeout(() => {
          this.gridOptions.api.sizeColumnsToFit();
        }, 100);
      }
    },
    autoSizeAll() {
      let allColumnIds = [];
      this.gridOptions.columnApi.getColumns().forEach(function (column) {
        allColumnIds.push(column.colId);
      });
      this.gridOptions.columnApi.autoSizeColumns(allColumnIds);
    },
    onSelectionChanged() {
      this.selectedRows = this.gridApi.getSelectedRows();
      this.$emit("selectionChanged", this.selectedRows);
    },
    setSelection(selectedElementIdArray) {
      this.gridApi.forEachNode((node) => {
        node.setSelected(
          selectedElementIdArray.findIndex((item) => item == node.data.id) > -1
        );
      });
    },
    clearSearch() {
      this.search = null;
      this.itemsPerPageChanged(this.itemsPerPage);
    },
    applyGridSort(key, type) {
      if (this.filters && !this.filters.ordering) {
        this.filters.ordering = [];
      }

      if (type == null) {
        delete this.sorting[key];
        this.filters.ordering.splice(
          this.filters.ordering.indexOf(`-${key}`),
          1
        );
      } else if (type == "asc") {
        this.filters.ordering.push(key);
      } else if (type == "desc") {
        this.filters.ordering.splice(
          this.filters.ordering.indexOf(key),
          1,
          `-${key}`
        );
      }
      if (this.filters.ordering.length == 0) {
        delete this.filters.ordering;
      }
      this.itemsPerPageChanged(this.itemsPerPage);
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    itemsPerPageChanged(e) {
      this.pageNo = 1;
      this.itemsPerPage = e;
      if (this.search) {
        this.filters.search = this.search.trim();
      } else {
        delete this.filters.search;
      }

      this.$emit("getList", {
        ...this.filters,
        offset: this.offset,
        limit: this.itemsPerPage,
      });
    },
    prevPage() {
      this.pageNo--;
      if (this.paginationTimeout) {
        clearTimeout(this.paginationTimeout);
      }
      this.paginationTimeout = setTimeout(() => {
        this.$emit("getList", {
          ...this.filters,
          offset: this.offset,
          limit: this.itemsPerPage,
        });
      }, 100);
    },
    nextPage() {
      this.pageNo++;
      if (this.paginationTimeout) {
        clearTimeout(this.paginationTimeout);
      }
      this.paginationTimeout = setTimeout(() => {
        this.$emit("getList", {
          ...this.filters,
          offset: this.offset,
          limit: this.itemsPerPage,
        });
      }, 100);
    },
    autoSizeAll() {
      if (!this.hasOtherGridOptions) {
        let allColumnIds = [];
        this.gridOptions.columnApi.getColumns().forEach(function (column) {
          allColumnIds.push(column.colId);
        });
        this.gridOptions.columnApi.autoSizeColumns(allColumnIds);
      } else {
        let allColumnIds = [];
        this.otherGridOption.columnApi.getColumns().forEach(function (column) {
          allColumnIds.push(column.colId);
        });
        this.otherGridOption.columnApi.autoSizeColumns(allColumnIds);
      }
    },
    refreshList() {
      this.$emit("getList", {
        ...this.filters,
        offset: this.offset,
        limit: this.itemsPerPage,
      });
    },
  },
  mounted() {
    if (this.initialCall) {
      this.$emit("getList", {
        ...this.filters,
        offset: this.offset,
        limit: this.itemsPerPage,
      });
    }
    if (this.setInterval) {
      this.timeInterval = setInterval(() => {
        this.$emit("getList", {
          ...this.filters,
          offset: this.offset,
          limit: this.itemsPerPage,
        });
      }, this.setIntervalDuration);
    }
  },
  beforeDestroy() {
    if (this.timeInterval) {
      clearInterval(this.timeInterval);
    }
  },
};
</script>
<style scoped>
</style>
